//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/TaggedObject.js";
let d=[[[0,"CustomOrientationMethod",1,0],[0,"CustomXAngle",1,0],[0,"CustomYAngle",1,0],[0,"CustomZAngle",1,0],[0,"OrientationType",1,0]],[[[],"GetCustomNormalX",{R_:{component:''}},0,0],[["component"],"SetCustomNormalX",{},1,0],[[],"GetCustomNormalY",{R_:{component:''}},0,0],[["component"],"SetCustomNormalY",{},1,0],[[],"GetCustomNormalZ",{R_:{component:''}},0,0],[["component"],"SetCustomNormalZ",{},1,0],[[],"GetInferredPrimary",{R_:{inferred:''}},0,0],[["inferred"],"SetInferredPrimary",{},1,0],[[],"GetCustomPrimaryX",{R_:{component:''}},0,0],[["component"],"SetCustomPrimaryX",{},1,0],[[],"GetCustomPrimaryY",{R_:{component:''}},0,0],[["component"],"SetCustomPrimaryY",{},1,0],[[],"GetCustomPrimaryZ",{R_:{component:''}},0,0],[["component"],"SetCustomPrimaryZ",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Drawings.View2dOrientBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.View2dOrientBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.View2dOrientBuilder.Type = Object.freeze({
    "None" : "None", "Top" : "Top", "Front" : "Front", "Right" : "Right", "Back" : "Back", "Bottom" : "Bottom", "Left" : "Left", "Iso" : "Iso", "Tri" : "Tri", "Custom" : "Custom"});

SPLM.Drawings.View2dOrientBuilder.CustomMethod = Object.freeze({
    "Angles" : "Angles", "Vector" : "Vector"});

export default SPLM;